
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  onMounted,
  ref,
} from 'vue'
import { required } from '@/utils/rules'
import { updateSyncTime } from './api'
import { ElMessage } from 'element-plus'
import { toResult } from '@/utils/toResult'
import moment from 'moment'

export default defineComponent({
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      required: true,
      default: false,
    },
    row: {
      type: Object,
      default: () => {},
    },
    isType: {
      type: Object,
      default: () => {},
    },
  },
  // emits: ['update:modelValue'],
  setup(props, { emit }) {
    const data = reactive({
      visible: false,
      titlename: '调整同步时间',
      formRef: undefined,
      formData: ref<any>({}),
      id: 0,
      rules: {
        lastViolationSyncTime: [required],
        lastViolationTime: [required],
      },
    })

    watchEffect(() => {
      data.visible = props.modelValue
    })

    /**
     * @description: 关闭dialog
     * @param {*} void
     * @return {*}
     */
    const onCancel = (): void => {
      data.visible = false
      emit('update:modelValue', false)
      emit('getListFn')
    }
    const init = () => {
      data.formData = props.row || []
      data.id = props.row.id || null
    }

    // 提交表单
    const handleSubmit = () => {
      data.formRef.validate(async (valid) => {
        if (valid) {
          const p: any = {
            lastViolationSyncTime: moment(
              data.formData.lastViolationSyncTime
            ).format('YYYY-MM-DD HH:mm:ss'),
            lastViolationTime: moment(data.formData.lastViolationTime).format(
              'YYYY-MM-DD HH:mm:ss'
            ),
            id: data.id || 0,
          }
          const [err] = await toResult(updateSyncTime(p))
          if (err) return false
          ElMessage.success('操作成功')
          onCancel()
        }
      })
    }

    onMounted(() => {
      init()
    })
    return {
      ...toRefs(data),
      handleSubmit,
      onCancel,
      init,
    }
  },
})
